import { FormInstance } from "antd";
import { useEffect, useMemo, useState } from "react";
import { useTransformRequest } from "../../../../../Account/components/View/Admin/Details/components/PayeeDisbursements/hooks/useTransformRequest";

export const useSetInitialValues = (record: any, form: FormInstance) => {
  const { transform } = useTransformRequest(false);

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const disbursementMethodState = useMemo(() => {
    return record && record.index
      ? {
          isEscrowAcc: record.method === 8,
          isACHMethod: record.method >= 5 && record.method <= 7,
        }
      : { isEscrowAcc: false, isACHMethod: false };
  }, [record]);

  useEffect(() => {
    if (record.index) {
      const { type, method } = record;

      const data = { ...record };
      transform(data);

      form.setFieldsValue({
        ...data,
        type: type === 101 ? "Impound Distribution" : type,
        method: method === 9 ? "Copy" : method,
      });
    }

    setIsLoading(false);
  }, [record, form, transform]);

  return { disbursementMethodState, isLoading };
};
